module.exports = __webpack_public_path__ + "static/media/Arcesium-logo.5b96aaa7.png";